import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DeliveryBranchMiniEntity } from '../../domain/entities/DeliveryBranchMiniEntity'
import type { DeliveryDiscountListedAdminDto } from '@/backend/market'

export class DeliveryBranchMiniModel extends DeliveryBranchMiniEntity {
  constructor(dataDto: DeliveryDiscountListedAdminDto) {
    super()
    mapEntityProperties<DeliveryBranchMiniModel>(this, dataDto)
  }
}
